import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn = async (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // console.log('authGuard - checking authentication');
  
  // Check if user is logged in (includes token expiration check)
  if (!authService.isLoggedIn()) {
    
    // If token exists but is expired, try to refresh
    if (authService.getToken() && (await authService.isTokenExpired())) {
      // console.log('authGuard - attempting token refresh');
      try {
        const newTokenData = await authService.getNewToken();
        authService.saveToken(newTokenData);
        return true;
      } catch (error) {
        console.error('authGuard - token refresh failed:', error);
        authService.logout();
        return router.createUrlTree(['/auth/login'], {
          queryParams: { returnUrl: state.url }
        });
      }
    }
    
    // No token or refresh failed
    return router.createUrlTree(['/'], {
      queryParams: { returnUrl: state.url }
    });
  }

  console.log('authGuard - authentication successful');
  return true;
};